import type { LogEvent, LogEventWithOptions, LogEvents, ReportLogEventsInput } from '../events';

import { filterNullishProperties } from './filterUndefinedEventPropertiesInput';
import { getApplicationContextInput } from './getApplicationContextInput';
import { getLogEventInput } from './getTelemetryEventInput';

type GetLogEventInputWithContext = (event: LogEvent) => LogEventWithOptions;
export const getLogEventInputWithContext: GetLogEventInputWithContext = (event) => {
  const { event: logEventInput, options } = getLogEventInput(event);
  const {
    ClientId,
    first_party_client,
    client_load_id,
    client_load_time,
    yamjs_revision,
    environment,
    UserId,
    NetworkId,
  } = getApplicationContextInput();

  return {
    event: {
      ...logEventInput,
      ...(ClientId && { ClientId }),
      ...(UserId && { UserId: Number(UserId) }),
      ...(NetworkId && { NetworkId: Number(NetworkId) }),
      Parameters: filterNullishProperties({
        ...logEventInput.Parameters,
        first_party_client,
        client_load_id,
        client_load_time,
        yamjs_revision,
        environment,
      }),
    },
    options,
  };
};

type GetReportLogEventsInput = (logEvents: LogEvents) => Promise<ReportLogEventsInput>;
export const getReportLogEventsInput: GetReportLogEventsInput = (logEvents) =>
  Promise.resolve().then(() => {
    const { errorEvents, performanceEvents, infoEvents } = logEvents;

    return {
      errorEvents: errorEvents.map(getLogEventInputWithContext),
      infoEvents: infoEvents.map(getLogEventInputWithContext),
      performanceEvents: performanceEvents.map(getLogEventInputWithContext),
    };
  });
